<template>
  <div id="app">
    <div id="site-container" class="site-container">
      <kambly-header></kambly-header>
      <div id="page" class="page">
        <main class="main">
          <main-content :content="mainContent"></main-content>
          <div id="prices">
            <price-container :title="content.mainPricesTitle" :prices="content.mainPrices"></price-container>
            <price-container :title="content.pricesTitle" :prices="content.prices"></price-container>
          </div>
          <big-content v-if="content.content" class="main__big-content" :content="content.content[0]"></big-content>
          <div id="benefits">
            <benefit-container :title="content.benefitsTitle" :benefits="content.benefits"></benefit-container>
          </div>
          <teaser-image :items="content.itemsBig"></teaser-image>
          <overlay v-if="overlayOpen"></overlay>
          <modal v-if="this.$config.default.COMPETITION_FINISHED === 'true'"
                 :title="content.competitionFinishedContent.title"
                 :text="content.competitionFinishedContent.text" />
        </main>
        <kambly-footer></kambly-footer>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import KamblyHeader from './components/KamblyHeader'
import PriceContainer from "./components/PriceContainer";
import BigContent from "./components/BigContent";
import BenefitContainer from "./components/BenefitContainer";
import TeaserImage from "./components/TeaserImage";
import MainContent from "./components/MainContent";
import Overlay from "./components/Overlay";
import KamblyFooter from "./components/KamblyFooter";
import TermsCond from "./components/TermsCond";

export default {
  name: 'app',
  components: {
      Overlay,
      TeaserImage,
      BigContent,
      PriceContainer,
      KamblyHeader,
      BenefitContainer,
      MainContent,
      KamblyFooter,
      TermsCond
  },
  computed: {
      ...mapGetters([
          'content',
          'overlayOpen'
      ]),
      mainContent() {
          return {
              title: this.content.title,
              tagline: this.content.tagline
          }
      }
  },
  methods: {
    ...mapActions([
        'initLanguages',
        'setContestType'
    ])
  },
  created() {
    this.initLanguages();
  }
}
</script>

<style lang="scss">
  @import 'assets/sass/variables';
  @import 'assets/sass/legacy-pro';
  @import 'assets/frontend_old.css';

  * {
    -webkit-font-smoothing: antialiased;
  }

  body {
    margin: 0;
  }

  .no-scroll {
    overflow: hidden;
  }

  .main {
    &__big-content {
      @media (min-width: 768px) {
        margin-bottom: 0;
      }

      margin-bottom: 0;
    }
  }

  .teaser-image.container {
    margin-bottom: 50px;
  }

  .terms-cond__content {
    width: 80vw;
  }

  @font-face {
    font-weight: $font-weight-normal;
    font-family: LegacyPro;
    font-display: swap;
    src: url("assets/fonts/legacy-book/font.woff2") format("woff2"), url("assets/fonts/legacy-book/font.woff") format("woff");
  }

  @font-face {
    font-weight: $font-weight-bold;
    font-family: LegacyPro;
    font-display: swap;
    src: url("assets/fonts/legacy-bold/font.woff2") format("woff2"), url("assets/fonts/legacy-bold/font.woff") format("woff");
  }

  @font-face {
    font-weight: $font-weight-extra-light;
    font-family: SofiaPro;
    src: url("assets/fonts/SofiaPro-ExtraLight.eot");
    src: url("assets/fonts/SofiaPro-ExtraLight.eot?#iefix") format("embedded-opentype"), url("assets/fonts/SofiaPro-ExtraLight.woff2") format("woff2"), url("assets/fonts/SofiaPro-ExtraLight.woff") format("woff"), url("assets/fonts/SofiaPro-ExtraLight.ttf") format("truetype");
  }

  @font-face {
    font-weight: $font-weight-light;
    font-family: SofiaPro;
    src: url("assets/fonts/SofiaPro-Light.eot");
    src: url("assets/fonts/SofiaPro-Light.eot?#iefix") format("embedded-opentype"), url("assets/fonts/SofiaPro-Light.woff2") format("woff2"), url("assets/fonts/SofiaPro-Light.woff") format("woff"), url("assets/fonts/SofiaPro-Light.ttf") format("truetype");
  }

  @font-face {
    font-weight: $font-weight-normal;
    font-family: SofiaPro;
    src: url("assets/fonts/SofiaPro-Regular.eot");
    src: url("assets/fonts/SofiaPro-Regular.eot?#iefix") format("embedded-opentype"), url("assets/fonts/SofiaPro-Regular.woff2") format("woff2"), url("assets/fonts/SofiaPro-Regular.woff") format("woff"), url("assets/fonts/SofiaPro-Regular.ttf") format("truetype");
  }

  @font-face {
    font-weight: $font-weight-medium;
    font-family: SofiaPro;
    src: url("assets/fonts/SofiaPro-Medium.eot");
    src: url("assets/fonts/SofiaPro-Medium.eot?#iefix") format("embedded-opentype"), url("assets/fonts/SofiaPro-Medium.woff2") format("woff2"), url("assets/fonts/SofiaPro-Medium.woff") format("woff"), url("assets/fonts/SofiaPro-Medium.ttf") format("truetype");
  }

  @font-face {
    font-weight: $font-weight-semi-bold;
    font-family: SofiaPro;
    src: url("assets/fonts/SofiaPro-SemiBold.eot");
    src: url("assets/fonts/SofiaPro-SemiBold.eot?#iefix") format("embedded-opentype"), url("assets/fonts/SofiaPro-SemiBold.woff2") format("woff2"), url("assets/fonts/SofiaPro-SemiBold.woff") format("woff"), url("assets/fonts/SofiaPro-SemiBold.ttf") format("truetype");
  }

  @font-face {
    font-weight: $font-weight-bold;
    font-family: SofiaPro;
    src: url("assets/fonts/SofiaPro-Bold.eot");
    src: url("assets/fonts/SofiaPro-Bold.eot?#iefix") format("embedded-opentype"), url("assets/fonts/SofiaPro-Bold.woff2") format("woff2"), url("assets/fonts/SofiaPro-Bold.woff") format("woff"), url("assets/fonts/SofiaPro-Bold.ttf") format("truetype");
  }

  @font-face {
    font-weight: normal;
    font-style: normal;
    font-family: icomoon-frontend;
    src: url("assets/fonts/icomoon-frontend.eot");
    src: url("assets/fonts/icomoon-frontend.eot?k9ndfd#iefix") format("embedded-opentype"),
    url("assets/fonts/icomoon-frontend.ttf") format("truetype"),
    url("assets/fonts/icomoon-frontend.woff") format("woff"),
    url("assets/fonts/icomoon-frontend.svg?k9ndfd#icomoon-frontend") format("svg");
  }

  .site-container {
    display: inherit;

    &__title {
      margin-bottom: 30px;
      text-align: center;
    }
  }

  @media (min-width: 1440px) {
    .page {
      padding-top: 200px;
    }
  }
</style>
